import { render, staticRenderFns } from "./BlogSectionSimple.vue?vue&type=template&id=7469ff48"
import script from "./BlogSectionSimple.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlogSectionSimple.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports